import type { LayerSpecification } from "maplibre-gl";

import { SOURCES } from "../sources";
import { LAYERS } from "./constants";

export const tracks: LayerSpecification = {
  id: LAYERS.TRACKS,
  type: "line",
  source: SOURCES.TRACKS,
  layout: {
    "line-cap": "round",
    "line-join": "round",
  },
  paint: {
    "line-width": 1,
    "line-gradient": [
      "interpolate",
      ["linear"],
      ["-", 1, ["line-progress"]],
      0.0,
      "rgba(255, 200, 120, 0.65)",
      0.9,
      "rgba(255, 150, 60, 0.35)",
      1.0,
      "rgba(255, 120, 40, 0.0)",
    ],
  },
};
